import {
  Grid,
  HorizontalLine,
  LabelKey,
  LabelValue,
} from './VariableCard.styled';
import { IFormattedVariable } from '../helpers';

interface IVariableCardProps {
  variable: IFormattedVariable;
  isLast: boolean;
}

// Variable names come from the model, so they are not translatable the way the
// BOM column headers are - they are rendered as they are defined.
export const VariableCard = ({ variable, isLast }: IVariableCardProps) => {
  return (
    <>
      <Grid>
        <LabelKey>{variable.name}:</LabelKey>
        <LabelValue>{variable.value}</LabelValue>
      </Grid>
      {isLast ? null : <HorizontalLine />}
    </>
  );
};
